import Main from './Main';
export default Main;



// WEBPACK FOOTER //
// ./src/containers/Main/index.js